module.exports = __webpack_public_path__ + "img/bay-loreto.87f3ec2e.jpg";